import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import request from 'superagent';

import { GOOGLE } from '../globals/config';
import { I18N, API_KEY } from '../globals/wp';
import { userLocationRoute } from '../utils/data/routes';

import styles from './get-location.pcss';

/**
 * Powers the geolocation api request and handling.
 */

export default class GetLocation extends PureComponent {
	static propTypes = {
		handleUpdate: PropTypes.func,
		navigate: PropTypes.func,
		radius: PropTypes.string.isRequired,
	};

	static defaultProps = {
		handleUpdate: () => {},
		navigate: () => {},
	};

	state = {
		loading: false,
	};

	/**
	 * Handles updating the router with the users location
	 * @param position
	 */

	onUserPositionSuccess = (position) => {
		if (!API_KEY) {
			console.warn('Locator: No Google API Key provided');
			return;
		}
		request
			.get(`${GOOGLE.geocode_url}?latlng=${position.coords.latitude},${position.coords.longitude}&key=${API_KEY}`)
			.end((err, res) => {
				if (!err) {
					if (res.body && res.body.error_message) {
						console.warn(`Error fetching reverse geocode information from google : ${res.body.error_message}`);
					} else if (res.body.status !== 'OK') {
						console.warn(`Error fetching reverse geocode information from google : ${res.body.status}`);
					} else {
						this.props.navigate(userLocationRoute(res.body, this.props.radius)).then(() => this.props.handleUpdate());
					}
				} else {
					console.warn('Error fetching reverse geocode information from google');
				}
				this.setState({
					loading: false,
				});
			});
	};

	/**
	 * Lets the user know about any errors encountered getting the position from them.
	 *
	 * @param error
	 */

	onUserPositionFail = (error) => {
		this.setState({
			loading: false,
		}, () => {
			switch (error.code) {
			case error.PERMISSION_DENIED:
				console.warn('User denied the request for Geolocation');
				break;
			case error.POSITION_UNAVAILABLE:
				alert(I18N.geolocation_not_avail); // eslint-disable-line no-alert
				break;
			case error.TIMEOUT:
				alert(I18N.geolocation_timeout); // eslint-disable-line no-alert
				break;
			default:
				alert(I18N.geolocation_default_err); // eslint-disable-line no-alert
			}
		});
	};

	/**
	 * Sets a loading state and starts the request process.
	 */

	getLocation = () => {
		if (this.state.loading) {
			return;
		}

		if (!navigator.geolocation) {
			alert(I18N.no_html5_geolocation); // eslint-disable-line no-alert
			return;
		}

		this.setState({ loading: true }, () => {
			navigator.geolocation.getCurrentPosition(this.onUserPositionSuccess, this.onUserPositionFail, {
				enableHighAccuracy: true,
				timeout: 10000,
				maximumAge: 0,
			});
		});
	};

	render() {
		const title = this.state.loading ? '' : I18N.get_location;
		const getLocationLabel = I18N.get_location_label;
		const containerClasses = classNames({
			[styles.container]: true,
			'get-user-location-btn': true,
			'loading': this.state.loading,
		});
		const buttonContainerClasses = classNames({
			[styles.button_container]: true,
		});
		const spanClasses = classNames({
			[styles.location_label]: true,
		});
		const iconClasses = classNames({
			[styles.icon]: !this.state.loading,
			[styles.loader]: this.state.loading,
			'icon': !this.state.loading,
			'icon-target': !this.state.loading,
		});

		return (
			<div className={containerClasses} onClick={this.getLocation}>
				<div className={buttonContainerClasses}>
					<button className={styles.button} title={title}>
						<span className={iconClasses}></span>
						<span className={spanClasses}>{getLocationLabel}</span>
					</button>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/get-location.js